import React, { useState, useEffect } from "react";
import { getAllState, getAllDistrict, getAllRevenueCircle, getCategoryList } from '../resourceCommonAPIs';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { FETCH_ALL_RATE_CONFIRMATION } from "../../../common/URLs";

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { format } from 'date-fns';
import { loaderService } from "../../../common/custom-loader/loader-service";
import CustomDataGridPdfToolbar from "../../../common/customDataGridPdfToolbar";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Tab, Typography } from "@mui/material";
import { DownloadIcon, ExpandIcon } from "../../../common/icons";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import { DISTRICT, REVENUE_CIRCLE, STATE } from "../../../common/constants";
import { titleCase } from "../../../common/commonFunction";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { viewdownloadDocument } from "../knowledgeManagement/knowledgeMangementApi";
import apiClient from "../../../axios";

function ApprovedRatesFromStakeholders() {

    const [allRates, setAllRates] = useState([]);
    const [tabValues, setTabValues] = useState({});
    const [uniqueIds, setUniqueIds] = useState([])

    const columns = [
        { field: 'requestId', headerName: 'Request ID', width: 180, hide: true },
        { field: 'stakeholderName', headerName: 'Stakeholder Name', width: 180 },
        { field: 'urnNumber', headerName: 'Stakeholder URN', width: 180 },
        { field: 'growerDbs', headerName: "DBS Grower", width: 100 },
        {
            field: 'state', headerName: STATE, width: 150,
            renderCell: (params) => {
                return (
                    params?.row?.state && titleCase(params?.row?.state)
                )
            }
        },
        {
            field: 'district', headerName: DISTRICT, width: 150,
            renderCell: (params) => {
                return (
                    params?.row?.district && titleCase(params?.row?.district)
                )
            }
        },
        {
            field: 'revenueCircle', headerName: REVENUE_CIRCLE, width: 150,
            renderCell: (params) => {
                return (
                    params?.row?.revenueCircle && titleCase(params?.row?.revenueCircle)
                )
            }
        },
        { field: 'landName', headerName: 'Land Name', width: 170 },
        { field: 'totalQuantity', headerName: "Total Qty(in MT)", width: 180 },
        { field: 'committedQuantity', headerName: "Committed Qty(in MT)", width: 180 },
        {
            field: 'validFrom', headerName: 'Valid From', width: 150,
            renderCell: (params) => {
                return (
                    <>
                        {format(new Date(params?.row?.validFrom), 'dd/MM/yyyy')}
                    </>
                )
            }
        },
        {
            field: 'validTo', headerName: 'Valid To', width: 150,
            renderCell: (params) => {
                return (
                    <>
                        {format(new Date(params?.row?.validTo), 'dd/MM/yyyy')}
                    </>
                )
            }
        },
        { field: 'itemRate', headerName: 'Item Rate(in INR)', width: 130 },
        { field: 'status', headerName: 'Status', width: 150 },
        { field: 'proposeRate', headerName: 'Proposed Rate', width: 130 },
        {
            field: 'fileName',
            headerName: "File",
            width: 300,
            renderCell: (params) => {
                return (
                    <div className="Rescview-file-link-common">
                        <Typography onClick={(e) => viewdownloadDocument(params?.row?.rateCardDocumentMasterEnity?.[0]?.documentGuid, params?.row?.rateCardDocumentMasterEnity?.[0]?.documentName, "View")} >
                            {params?.row?.rateCardDocumentMasterEnity?.[0]?.documentName}
                        </Typography>
                    </div>
                );
            }
        },]

    useEffect(() => {
        fetchAllRate();
    }, []);

    function fetchAllRate() {
        loaderService.showLoader();
        apiClient
            .post(
                FETCH_ALL_RATE_CONFIRMATION, {
            },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                loaderService.hideLoader();
                const tempAllRates = response?.data?.rateConfirmationList
                setAllRates(tempAllRates)
                const tempIds = [...new Set(tempAllRates?.map(item => item.requestId))].map(requestId => ({
                    requestId,
                    totalQuantity: tempAllRates.reduce((sum, item) => (item.requestId === requestId ? sum + Number(item?.totalQuantity) : sum), 0).toFixed(4),
                    committedQuantity: tempAllRates.reduce((sum, item) => (item.requestId === requestId ? sum + Number(item?.committedQuantity) : sum), 0).toFixed(4),
                }))
                setUniqueIds(tempIds);
                setTabValues(tempIds?.reduce((arr, item) => {
                    arr[item?.requestId] = 0;
                    return arr
                }, {}))
            })
            .catch(function (error) {
                loaderService.hideLoader();
                console.log(error);
            });
    }

    const handleTabChange = (requestId, newValue) => {
        setTabValues((prev) => ({ ...prev, [requestId]: newValue }));
    }

    const downloadPdf = () => {
        const columns1 = [
            { field: 'requestId', headerName: 'Request ID', width: 180, hide: true },
            { field: 'stakeholderName', headerName: 'Stakeholder Name', width: 180 },
            { field: 'urnNumber', headerName: 'Stakeholder URN', width: 180 },
            { field: 'growerDbs', headerName: "DBS Grower", width: 100 },
            {
                field: 'state', headerName: STATE, width: 150,
                renderCell: (params) => {
                    return (
                        params?.row?.state && titleCase(params?.row?.state)
                    )
                }
            },
            {
                field: 'district', headerName: DISTRICT, width: 150,
                renderCell: (params) => {
                    return (
                        params?.row?.district && titleCase(params?.row?.district)
                    )
                }
            },
            {
                field: 'revenueCircle', headerName: REVENUE_CIRCLE, width: 150,
                renderCell: (params) => {
                    return (
                        params?.row?.revenueCircle && titleCase(params?.row?.revenueCircle)
                    )
                }
            },]
            const columns2 =[
            { field: 'landName', headerName: 'Land Name', width: 170 },
            { field: 'totalQuantity', headerName: "Total Qty(in MT)", width: 180 },
            { field: 'committedQuantity', headerName: "Committed Qty(in MT)", width: 180 },
            {
                field: 'validFrom', headerName: 'Valid From', width: 150,
                renderCell: (params) => {
                    return (
                        <>
                            {format(new Date(params?.row?.validFrom), 'dd/MM/yyyy')}
                        </>
                    )
                }
            },
            {
                field: 'validTo', headerName: 'Valid To', width: 150,
                renderCell: (params) => {
                    return (
                        <>
                            {format(new Date(params?.row?.validTo), 'dd/MM/yyyy')}
                        </>
                    )
                }
            },
            { field: 'itemRate', headerName: 'Item Rate(in INR)', width: 130 },
            { field: 'status', headerName: 'Status', width: 150 },
            { field: 'proposeRate', headerName: 'Proposed Rate', width: 130 },
            ]
        const doc = new jsPDF();
        doc.setFont("helvetica", "bold")
        doc.text("ONLINE RATE CONFIRMATION", 60, 10);
        doc.setFont("helvetica", "normal")
        const tableColumn1 = columns1.map((col) => col.headerName);
        const tableColumn2 = columns2.map((col) => col.headerName);
        const acceptedTableRows = allRates.filter(item => item.status === "Accepted").map((row) => columns.map((col) => row[col.field]));
        const rejectedTableRows = allRates.filter(item => item.status === "Rejected").map((row) => columns.map((col) => row[col.field]));
        const proposedTableRows = allRates.filter(item => item.status === "Proposed").map((row) => columns.map((col) => row[col.field]));
        
        doc.setFontSize(14);
        // Function to add tables
        const addTable = (title, data, startY) => {
            doc.setFontSize(14);
            doc.text(title, 14, startY);
            doc.autoTable({
                startY: startY + 5,
                head: title !== "Proposed" ? [tableColumn1?.filter(item => item != "Proposed Rate")] : [tableColumn1],
                body: data.map(row => row.slice(0,7)),
            });
            startY=doc.lastAutoTable.finalY + 5
            doc.autoTable({
                startY,
                head: title !== "Proposed" ? [tableColumn2?.filter(item => item != "Proposed Rate")] : [tableColumn2],
                body: data.map(row => row.slice(7)),
            });
            return doc.lastAutoTable.finalY + 10;
        };
        let startY = 30;
        addTable("Accepted", acceptedTableRows, startY);
        startY = doc.lastAutoTable.finalY + 10;
        addTable("Rejected", rejectedTableRows, startY);
        startY = doc.lastAutoTable.finalY + 10;
        addTable("Proposed", proposedTableRows, startY);
        const finalY = doc.lastAutoTable.finalY || 30;
        doc.setFontSize(10);
        doc.text("Recommended By:", 150, finalY + 20);
        doc.save("allRates.pdf");
    };

    return (
        <>
            <Grid container mb={2}>
                <Grid item xs={12} startIcon={<DownloadIcon />} onClick={downloadPdf} display='flex' justifyContent="flex-end"><Button mb={2} variant="contained">Download as PDF</Button></Grid>
            </Grid>
            {uniqueIds?.map(uniqueItem => (
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Box display='flex' justifyContent="space-between">
                        <Typography variant="subtitle2" >{`Request ID: ${uniqueItem?.requestId}`}</Typography>
                        <Typography variant="body2" ml={5}>{`Total Qty(in MT): ${uniqueItem?.totalQuantity} Committed Qty(in MT): ${uniqueItem?.committedQuantity}`}</Typography>
                        </Box>
                        </AccordionSummary>
                    <AccordionDetails>
                        <TabContext value={tabValues[uniqueItem?.requestId]}>
                            <TabList onChange={(e, newValue) => handleTabChange(uniqueItem?.requestId, newValue)} aria-label="lab API tabs example">
                                <Tab label="Accepted" value={0} />
                                <Tab label="Rejected" value={1} />
                                <Tab label="Proposed New Rate" value={2} />
                                <Tab label="Pending Rates" value={3} />
                            </TabList>
                            <TabPanel value={0}>
                                <DataGrid
                                    autoHeight
                                    rows={allRates?.filter(item => item.requestId === uniqueItem?.requestId && item.status === "Accepted")}
                                    columns={columns}
                                    pageSize={10} />
                            </TabPanel>
                            <TabPanel value={1}>
                                <DataGrid
                                    autoHeight
                                    rows={allRates?.filter(item => item.requestId === uniqueItem?.requestId && item.status === "Rejected")}
                                    columns={columns}
                                    pageSize={10} />
                            </TabPanel>
                            <TabPanel value={2}>
                                <DataGrid
                                    autoHeight
                                    rows={allRates?.filter(item => item.requestId === uniqueItem?.requestId && item.status === "Proposed")}
                                    columns={columns}
                                    pageSize={10} />
                            </TabPanel>
                            <TabPanel value={3}>
                                <DataGrid
                                    autoHeight
                                    rows={allRates?.filter(item => item.requestId === uniqueItem?.requestId && !item.status)}
                                    columns={columns}
                                    pageSize={10} />
                            </TabPanel>
                        </TabContext>
                    </AccordionDetails>
                </Accordion>))}

        </>
    )
}
export default ApprovedRatesFromStakeholders;